module.exports = __webpack_public_path__ + "static/media/login.f56c4790.svg";